<template>
  <div class="pt-3">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="card">
            <div class="col-12">
              <div class="row">
                <div class="col-12 py-3 px-4 pt-4">
                  <div class="d-flex justify-content-between">
                    <h3
                      class="mt-0 mb-2 text-title-dashboard my-2 font-weight-bold"
                    >
                      Nueva Promoción
                    </h3>
                    <div class="">
                      <button
                        class="mt-2 btn-sm bg-primary text-white font-weight-normal border btn-outline-primary h5 btn d-flex flex-nowrap align-items-center"
                        @click.prevent="returnUrl"
                      >
                        <i class="bi bi-arrow-left mr-1"></i>
                        Volver
                      </button>
                    </div>
                  </div>
                  <form>
                    <div class="row">
                      <div class="col-12 col-sm-4 pl-0">
                        <div id="app">
                          <file-pond
                            name="test"
                            ref="filePond"
                            label-idle=" Agrega la imagen aquí<br>( resolución recomendada: 1200x800 )"
                            v-bind:allow-multiple="false"
                            accepted-file-types="image/jpeg, image/png"
                            :server="null"
                            v-bind:files="form.url_image"
                            @addfile="handleFileAdd"
                            @removefile="handleFileRemove"
                          />
                        </div>
                      </div>
                      <div class="col-12 col-sm-8 px-0 pl-3">
                        <div class="row">
                          <div class="col-12 col-md-6 pr-md-2 pr-0 pl-0 py-0">
                            <label for="">Nombre del Aliado</label>
                            <input
                              type="text"
                              placeholder="Aliado"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.ally"
                              required
                            />
                          </div>
                          <div class="col-12 col-md-6 pl-md-2 pl-0 pr-0 py-0">
                            <label for="">Fecha de inicio</label>
                            <input
                              type="date"
                              placeholder="Apellido"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.date"
                              required
                            />
                          </div>
                          <div class="col-12 col-md-6 pr-md-2 pr-0 pl-0 py-0">
                            <label for="">Título de la promoción</label>
                            <input
                              type="text"
                              placeholder="Título de la promoción"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.title"
                              required
                            />
                          </div>
                          <div class="col-12 col-md-6 pl-md-2 pl-0 pr-0 py-0">
                            <label for="">Porcentaje de descuento</label>
                            <input
                              type="number"
                              placeholder="10%"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model.number="form.percentage"
                              min="0"
                              max="100"
                              @input="validatePercentage"
                            />
                          </div>
                          <div class="col-12 col-md-6 pr-md-2 pr-0 pl-0 py-0">
                            <label for="">Descripción</label>
                            <textarea
                              cols="30"
                              rows="10"
                              placeholder="Descripción"
                              class="form-control form-control-sm mt-1 mb-2"
                              v-model="form.description"
                              style="height: 100px"
                            ></textarea>
                          </div>

                          <div class="col-6 pl-0 pr-0" v-if="false">
                            <div class="d-flex">
                              <label for="status" class="pt-1 mr-4"
                                >Promoción activa:</label
                              >
                              <div style="padding-top: 2px">
                                <input
                                  type="checkbox"
                                  id="status"
                                  v-model="form.id_type_promotion_status"
                                  class="form-check-input mt-1 mb-3"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="d-flex justify-content-end w-100 mt-2">
                        <button
                          class="bg-primary text-white font-weight-normal border btn-outline-primary h5 btn mb-0 mt-md-0 mb-2 mt-1"
                          @click.prevent="saveElement"
                        >
                          Guardar
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Swal from 'sweetalert2'

// Import Vue FilePond
import vueFilePond from 'vue-filepond'
import 'filepond/dist/filepond.min.css'
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type'
import FilePondPluginImagePreview from 'filepond-plugin-image-preview'

const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
)

export default {
  name: 'app',
  data() {
    return {
      form: {
        url_image: '',
        ally: '',
        date: '',
        title: '',
        percentage: '',
        description: '',
        id_type_promotion_status: true
      }
    }
  },
  methods: {
    ...mapActions(['createData', 'optimizeImage']),

    validatePercentage() {
      if (this.form.percentage > 100) {
        this.form.percentage = 100
      } else if (this.form.percentage < 0) {
        this.form.percentage = 0
      }
    },
    handleFileAdd(error, file) {
      if (!error) {
        this.form.url_image = [file.file]
      }
    },

    handleFileRemove(file) {
      this.form.url_image = []
    },

    saveElement() {
      const filePondInstanceValid = this.$refs.filePond.getFiles()

      if (
        this.form.ally === '' ||
        this.form.date === '' ||
        this.form.title === '' ||
        this.form.percentage === '' ||
        this.form.description === ''
      ) {
        Swal.fire({
          title: 'Atención',
          text: 'Por favor, complete todos los campos para continuar.',
          icon: 'warning',

          confirmButtonText: 'Aceptar'
        })
        return
      }
      if (filePondInstanceValid.length < 1) {
        Swal.fire({
          title: '¡Atención!',
          text: 'La imagen de la promoción es obligatoria.',
          icon: 'warning',

          confirmButtonText: 'Aceptar'
        })
        return
      }
      Swal.fire({
        title: '¡Atención!',
        text: '¿Estás seguro de guardar esta promoción?',
        icon: 'question',
        reverseButtons: true,
        showCancelButton: true,

        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Sí, Guardar'
      }).then(async (result) => {
        if (result.value) {
          const formData = new FormData()
          formData.append('ally', this.form.ally)
          formData.append('date', this.form.date)
          formData.append('title', this.form.title)
          formData.append('percentage', this.form.percentage)
          formData.append(
            'id_type_promotion_status',
            this.form.id_type_promotion_status ? 1 : 2
          )
          formData.append('description', this.form.description)
          const filePondInstance = this.$refs.filePond.getFiles()
          if (filePondInstance[0] && filePondInstance[0].file) {
            const compressedImage = await this.optimizeImage(
              filePondInstance[0].file
            )
            formData.append('url_image', compressedImage)
          }

          const form = {
            url: 'promotion/save',
            data: formData
          }

          this.createData(form)
            .then((response) => {
              if (response.code === 200) {
                Swal.fire({
                  title: 'Promoción guardada correctamente',
                  icon: 'success',

                  confirmButtonText: 'Aceptar'
                }).then(() => {
                  this.returnUrl()
                })
              } else if (response.code === 409) {
                Swal.fire({
                  title: 'Error',
                  text: 'Ya existe un promoción con este nombre.',
                  icon: 'error',

                  confirmButtonText: 'Aceptar'
                })
              }
            })
            .catch((error) => {
              console.error(error)
              Swal.fire({
                title: 'Error',
                text: 'Ocurrió un error, intente más tarde.',
                icon: 'error',

                confirmButtonText: 'Aceptar'
              })
            })
        }
      })
    },

    returnUrl() {
      this.$router.go(-1)
    }
  },
  components: {
    FilePond
  }
}
</script>

<style>
.filepond--credits {
  display: none !important;
}
</style>
